import React from "react";
import { Container, Typography, Box } from "@mui/material";

function PrivacyPolicy() {
  return (
    <Container
      maxWidth="100vw"
      sx={{
        background: "linear-gradient(to right, #001f3f, #003366, #004080)",
      }}
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ fontSize: "1.55rem", color: "white" }}
        align="center"
        gutterBottom
      >
        Privacy Policy
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
          gutterBottom
        >
          Introduction
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          Parivikshak takes your privacy seriously. We have created this Privacy
          Policy in order to demonstrate our firm commitment to your privacy.
          This Policy sets out how and why we collect, store, process and share
          your data. It also tells you what your rights are in relation to that
          data.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
          gutterBottom
        >
          What information do we collect?
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          Non-Identifiable Information
        </Typography>
        <ul>
          <Typography component="li" sx={{ color: "white", mb: 2 }}>
            As you use our websites, our servers may automatically log the
            standard data provided by your web browser. This data is considered
            “non-identifying information”, as it does not personally identify
            you on its own. It may include your browser type and version, the
            pages you visit, the time and date of your visit, the time spent on
            each page and other similar details.
          </Typography>
          <Typography component="li" sx={{ color: "white" }}>
            We may also collect data about the device you are using to access
            our website. This data may include the device type, operating
            system, unique device identifiers, device settings and geo-location
            data. What we collect can depend on the individual settings of your
            device and software. We recommend checking the policies of your
            device manufacturer or software provider to learn what information
            they make available to us.
          </Typography>
        </ul>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          Identifiable Information
        </Typography>
        <ul>
          <Typography component="li" sx={{ color: "white" }}>
            When visiting our websites, making use of our platform features or
            subscribing to our newsletter, you may be asked to provide certain
            personally identifiable information (“Personal Information”), such
            as your name, e-mail, home address, work address, telephone number,
            date of birth, payment information etc.
          </Typography>
        </ul>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
          gutterBottom
        >
          How we collect Information
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          We collect information by fair and lawful means, with your knowledge
          and consent.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          We use “cookies” to collect information about you and your activity
          across our site. A cookie is a small piece of data that our website
          stores on your computer, and accesses each time you visit, so we can
          understand how you use our site. This helps us serve you content based
          on preferences you have specified. Please refer to our Cookie Policy
          for more information.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          You are free to refuse our request for the aforementioned information
          with the understanding that we may be unable to provide you with some
          of your desired services without it.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          Information Usage
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          We primarily use your personal information for the purposes of
          granting you access to engage with certain areas of our site and to
          notify you of any changes to services. We may also use your personal
          details to contact you with updates about our websites and services,
          along with promotional content that we believe may be of interest to
          you. If you wish to opt out of receiving promotional content, you can
          follow the “unsubscribe” instructions provided alongside any
          promotional correspondence from us.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          We may use a combination of identifying and non-identifying
          information to understand who our visitors are, how they use our
          services, and how we may improve their experience of our website in
          future.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          Data processing and storage
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          The personal information we collect is stored and processed in the
          India. We only transfer data within jurisdictions subject to data
          protection laws that reflect our commitment to protecting the privacy
          of our users.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          We only retain personal information and data for as long as necessary
          to provide a service or to improve our services in future. While we
          retain this data, we will protect it within commercially acceptable
          means to prevent loss and theft, as well as unauthorised access,
          disclosure, copying, use or modification. That said, we advise that no
          method of electronic transmission or storage is 100% secure, and
          cannot guarantee absolute data security.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          If you request your personal information, be deleted or where your
          personal information becomes no longer relevant to our operations, we
          will erase it from our system within a reasonable timeframe.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          Third-party access to information
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          We work with a number of trusted third-party service providers for
          analytics tracking and user authentication.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          These third-party service providers may access our data solely for the
          purpose of performing specific tasks on our behalf. We do not share
          any personally identifying information with them without your explicit
          consent. We do not give them permission to disclose or use any of our
          data for any other purpose.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          Your rights
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          YOUR PRIVACY IS EXTREMELY IMPORTANT TO US. UPON ACCEPTANCE OF THESE
          Terms of USE YOU CONFIRM THAT YOU HAVE READ, UNDERSTOOD AND
          UNEQUIVOCALLY ACCEPTED OUR POLICIES, INCLUDING THE PROVISIONS OF OUR
          PRIVACY POLICY.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          You may address any complaints or discrepancies in relation to the
          processing (including storing and using) of your Personal Information
          (including Sensitive Personal Information) to:
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          Grievance Officer: XXXX, KA, 590006 IN, Email: contact@zenigmalabs.com
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          Changes to this policy
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          At our discretion, we may change this Privacy Policy to reflect
          current acceptable practices. Your continued use of this site after
          any changes to this Policy will be regarded as acceptance of our
          practices around privacy and personal information.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
          align="center"
          gutterBottom
        >
          Disclaimer
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          Parivikshak, owned by Sunratna Business Consultancy Private Limited,
          intends to provide clear information about its products and services.
          The information and data in the Website are generic in nature. Our
          efforts are to offer accurate and responsible data. We are not
          responsible for any sort of discrepancies.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          There is no purpose of violating any copyright or intellectual
          copyrights issues. All information provided on the portal Parivikshak is
          subject to the discretion of the same and is likely to change without
          any notice. Though, any changes in public utility will be communicated
          immediately in our portal.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          We have tried to maintain high standards in quality, clarity, and
          accuracy of the material posted on the portal. Parivikshak is not legally
          responsible for the same in any matter whatsoever. Employees,
          partners, and associated staff of Parivikshak are not accountable for any
          loss, harm, or damage due to usage of information from the portal.
          Customers are advised to use their own discretion in such matters. The
          information provided on the portal is of financial, insurance, and
          legal nature. It is a mutual understanding that customers association
          with the portal will be at the customer’s preference and risk.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          Visitors to this Website/portal and every third party is hereby
          informed that the owners of this Website/portal, are the
          intermediaries of the various financial institutions whose products
          are dealt with in this Website/portal. It is made abundantly clear
          that Sunratna Business Consultancy Private Limited, its directors,
          shareholders, officers and employees and Parivikshak are in no way
          responsible or liable for any one for his/her investment or credit buy
          decision(s) (availing any kind of loans or taking credit card through
          us), and every prospect/loan seeker/ investor/policy-holder shall be
          solely responsible for the consequences of his/her decision(s).
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: "white" }} paragraph>
          BEWARE OF FRAUDULENT PHONE CALLS AND E-MAILS. Parivikshak clarifies to
          public that Parivikshak or its officials will never ask customers/visitors
          to deposit any money/cash for any of our services. Public receiving
          such phone calls/emails are requested to intimate Parivikshak along with
          details at contact@zenigmalabs.com
        </Typography>
      </Box>
    </Container>
  );
}

export default PrivacyPolicy;
